import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year', label: '대상년도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
          afterFix: '년',
        }
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["대상년도", "대상 공정수", "증상호소자 수", "근골격계 부담 공정수", "조사기관", "조사기간", "차기실시 년도", "결과보고서 첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "대상 공정수",
        key: "body.대상공정수",
      },
      {
        name: "증상호소자 수",
        key: "body.증상호소자수",
      },
      {
        name: "근골격계 부담 공정수",
        key: "body.근골격계부담공정수",
      },
      {
        name: "조사기관",
        key: "body.조사기관",
      },
      {
        name: "조사기간",
        key: "body.조사기간",
      },
      {
        name: "차기실시 년도",
        key: "body.차기실시년도",
      },
      {
        name: "결과보고서 첨부",
        key: "body.결과보고서첨부",
        style: { minWidth: "120px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 사업장명
        case 1: return postContent.header.year; // 대상년도
        case 2: return func.getContent(value).subInfo.대상공정수 // 대상공정수
        case 3: return func.getContent(value).subInfo.증상호소자수 // 증상호소자수
        case 4: return func.getContent(value).subInfo.근골격계부담공정수 // 근골격계부담공정수
        case 5: return func.getContent(value).subInfo.조사기관 // 조사기관
        case 6: return `${func.getContent(value).subInfo.조사기간.sDate} ~ ${func.getContent(value).subInfo.조사기간.eDate}` // 조사기간
        case 7: return func.getContent(value).subInfo.차기실시년도 // 차기실시년도
        case 8: { // 결과보고서첨부
          const file = func.getContent(value).fileList
          return  {
            type: 'file',
            files: file,
          }
        }
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
